import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading text-center text-foreground-950">
            读者评价
          </h2>
          <p className="mt-3 text-sm text-foreground-500 text-center">
            听听读者们怎么说
          </p>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {commentsData.slice(0, 3).map((comment) => (
              <div
                key={comment.id}
                className="p-6 bg-background-50 rounded-2xl border border-background-200/70"
              >
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: comment.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  &ldquo;{comment.content}&rdquo;
                </p>
                <div className="mt-4 flex items-center gap-3 pt-4 border-t border-background-200/70">
                  <div className="w-9 h-9 rounded-full overflow-hidden shrink-0">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <span className="block text-sm font-semibold text-foreground-900 whitespace-nowrap">
                      {comment.name}
                    </span>
                    <span className="block text-xs text-foreground-400">{comment.date}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {commentsData.slice(3, 5).map((comment) => (
              <div
                key={comment.id}
                className="p-6 bg-background-50 rounded-2xl border border-background-200/70"
              >
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: comment.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  &ldquo;{comment.content}&rdquo;
                </p>
                <div className="mt-4 flex items-center gap-3 pt-4 border-t border-background-200/70">
                  <div className="w-9 h-9 rounded-full overflow-hidden shrink-0">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <span className="block text-sm font-semibold text-foreground-900 whitespace-nowrap">
                      {comment.name}
                    </span>
                    <span className="block text-xs text-foreground-400">{comment.date}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}